import React from "react";

import { StyleSheet, View, Dimensions, Text, Platform } from "react-native";

import MariNormalIcon from "./MariNormalIcon";
import MariPartyIcon from "./MariPartyIcon";
import MariTalkingIcon from "./MariTalkingIcon";

import MariLookUpIcon from "./MariLookUpIcon";
import AppConfig from "../../../../../config/AppConfig";
import MariSanta from "./MariSanta";
import { hasItems, isChristmasTime, isWeb } from "../../../../../helpers/utils";
import MariErrorIcon from "./MariErrorIcon";
import ManaButton from "../../ManaButton";
import AppTheme from "../../../AppTheme";
import Animation from "../../../animation/LotieView";
import { MoodColors } from "../../mood/MoodsHelper";

const { width: WIDTH } = Dimensions.get("window");

export default function Mari({
  mariOptions = {},
  onPress = () => {},
  source = "",
  isMenuActive = false,
}) {
  const {
    mariMessage,
    isSelected,
    isPartyTime = false,
    highlight,
    isLoading,
    hideMari,
    mariAction,
    mariActionLink,
  } = mariOptions;

  const messageModel =
    typeof mariMessage != "object" ? { message: mariMessage } : mariMessage;
  const { hasError, isFromEmptyState } = messageModel;

  const buttons = mariAction
    ? typeof Array.isArray(mariAction)
      ? mariAction
      : [mariAction]
    : null;

  const MariIconTag = isChristmasTime()
    ? MariSanta
    : AppConfig.IS_PARTY_TIME || isPartyTime
    ? MariPartyIcon
    : MariNormalIcon;

  const MariTalkingIconTag =
    hasError || isFromEmptyState
      ? MariErrorIcon
      : isChristmasTime()
      ? MariSanta
      : AppConfig.IS_PARTY_TIME || isPartyTime
      ? MariPartyIcon
      : MariTalkingIcon;

  return (
    <View
      style={[
        styles.container,
        messageModel.message ? styles.containerInfo : {},
        highlight ? styles.highlightText : {},
        hasError ? styles.containerError : {},
        isFromEmptyState ? styles.containerEmpty : {},
      ]}
    >
      <View style={styles.media}>
        <View style={styles.textContainer}>
          {/* Message */}
          {messageModel.message ? (
            <Text
              onPress={() => onPress(false)}
              style={[
                styles.message,
                highlight ? { color: AppTheme.almostBlack } : {},
                hasError ? styles.errorMessage : {},
              ]}
            >
              {messageModel.message}
            </Text>
          ) : null}

          {/* On Ignored integrations page */}
          {messageModel.description ? (
            <Text
              onPress={() => onPress(false)}
              style={[
                styles.description,
                highlight ? { color: AppTheme.almostBlack } : {},
              ]}
            >
              {messageModel.description}
            </Text>
          ) : null}
        </View>

        {/* Mari icon */}
        {isLoading ? (
          /* Loading animation */
          <Animation
            ref={(ref) => {
              ref?.play();
            }}
            style={{
              width: 65,
              height: 65,
            }}
            source={require("../../../../../assets/animations/mana-spin.json")}
            loop={true}
          />
        ) : messageModel.message ? (
          <View style={isSelected ? styles.highlightRound : {}}>
            <MariTalkingIconTag onPress={() => onPress()} source={source} />
          </View>
        ) : hideMari ? null : isMenuActive ? (
          <MariLookUpIcon onPress={() => onPress()} source={source} />
        ) : (
          <MariIconTag onPress={() => onPress()} source={source} />
        )}
      </View>

      {/* Buttons */}
      {messageModel.message && hasItems(buttons) ? (
        <>
          <View style={styles.butttonsContainer}>
            {buttons.map((button, index) =>
              button ? (
                <ManaButton
                  key={index}
                  hideShadow
                  isMainButton={!button.isDismiss}
                  text={button.text}
                  onPress={button.onPress}
                  style={[
                    button.style || styles.button,
                    index < buttons.length - 1 ? { marginRight: 6 } : {},
                  ]}
                  styleText={button.buttonTextStyle}
                />
              ) : null,
            )}
          </View>

          {mariActionLink ? (
            <Text
              onPress={mariActionLink.onPress}
              style={[styles.actionLink, mariActionLink.style]}
            >
              {mariActionLink.text}
            </Text>
          ) : null}
        </>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "auto",
    maxWidth: isWeb ? 411 : WIDTH,
    minHeight: 80,
    padding: 10,
  },
  containerInfo: {
    width: WIDTH,
    //backgroundColor: "#F8E585",
    backgroundColor: AppTheme.highlightColor,
  },
  containerError: {
    width: WIDTH,
    backgroundColor: "#063435",
  },
  containerEmpty: {
    width: WIDTH,
    backgroundColor: "#063435",
  },
  media: {
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
  },
  butttonsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginHorizontal: 6,
    marginTop: 10,
    paddingBottom: isWeb ? 0 : 20,
  },
  textContainer: {
    display: "flex",
    paddingLeft: 10,
    flex: 1,
  },
  message: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  errorMessage: {
    color: "#FFF",
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  highlightText: {
    backgroundColor: AppTheme.highlightColor,
  },
  highlightRound: {
    backgroundColor: AppTheme.highlightColor,
    borderRadius: 100,
    paddingTop: 5,
    paddingHorizontal: 3,
    paddingBottom: 0,
  },
  button: {
    maxWidth: "50%",
    height: 40,
  },
  actionLink: {
    width: "100%",
    marginTop: 17,
    marginBottom: 6,
    textAlign: "center",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
  },
});
